export default __webpack_public_path__ + "static/img-team-1-b8aa419c3a1813aaebc7c0405a41e457.png";